import styled from 'styled-components';

export const Wrapper = styled.div`
      font-family: Balsamiq Sans;
      margin: -8px;
      padding: 0px;
  `;
